import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '@/views/index/index'
import Home from '@/views/index/home'
import Users from '@/views/user/index'
import News from '@/views/news/index'
import List from '@/views/news/list'
import Details from '@/views/news/details'
import Info from '@/views/user/info'
import orders from '@/views/user/orders'
import inpro from '@/views/product/index'
import proList from '@/views/product/list'
import product from '@/views/product/detail'
import pand from '@/views/product/details'
import cart from '@/views/product/cart'
import rider from '@/views/product/rider'
import inwok from '@/views/works/index'
import works from '@/views/works/list'
import workDet from '@/views/works/detail'
import order from '@/views/product/order'
import address from '@/views/user/address'
import inc from '@/views/contact/index'
import contact from '@/views/contact/contact'
import ordDet from '@/views/user/details'
import password from '@/views/user/password'
import coll from '@/views/user/coll'
import gift from '@/views/user/gift'
import gifts from '@/views/user/gifts'
import coupon from '@/views/user/coupon'
import Login from '@/views/login/login'
import receive from '@/views/user/receive'
import account from '@/views/user/account'
import mail from '@/views/user/mail'
import email from '@/views/user/email'
import ord from '@/views/product/ord'
import register from '@/views/login/register'
import repa from '@/views/login/repa'



Vue.use(VueRouter)

const router = new VueRouter({
    routes: [{
        path: '/',
        redirect: '/index/home'
    }, {
        path: '/index',
        component: Index,
        children: [{
                path: '/index/home',
                component: Home
            }
        ]
    },{
        path: '/product',
        component: inpro,
		redirect: '/product/list',
		children: [
			{
			    path: '/product/list',
			    component: proList,
			},
			{
		        path: '/product/details',
		        component: product,
		    },{
		        path: '/product/order',
		        component: order,
		    },{
		        path: '/product/rider',
		        component: rider,
		    },{
		        path: '/product/cart',
		        component: cart,
		    },{
		        path: '/product/ord',
		        component: ord,
		    },{
		        path: '/product/pand',
		        component:pand
		    }
			
		]
    },{
        path: '/works',
        component: inwok,
		redirect: '/works/list',
		children: [
			{
			    path: '/works/list',
			    component: works,
			},{
			    path: '/works/detail',
			    component: workDet,
			}
			
		]
    },{
        path: '/contact',
        component: inc,
		redirect: '/contact/contact',
		children: [
			{
			    path: '/contact/contact',
			    component:contact,
			}
			
		]
    },{
        path: '/news',
        component: News,
		redirect: '/news/list',
		children: [
			{
			    path: '/news/list',
			    component: List,
			},
			{
		        path: '/news/details',
		        component: Details,
		    }
			
		]
    },{
        path: '/user',
        component: Users,
		redirect: '/user/user',
		children: [
			{
			    path: '/user/info',
			    component: Info,
			},{
			    path: '/user/address',
			    component: address,
			},{
			    path: '/user/orders',
			    component: orders,
			},{
			    path: '/user/details',
			    component: ordDet,
			},{
			    path: '/user/password',
			    component: password,
			},{
			    path: '/user/coll',
			    component:coll,
			},{
			    path: '/user/gift',
			    component:gift
			},{
			    path: '/user/coupon',
			    component:coupon
			},{
			    path: '/user/receive',
			    component:receive
			},{
			    path: '/user/account',
			    component:account
			},{
			    path: '/user/mail',
			    component:mail
			},{
			    path: '/user/email',
			    component:email
			},{
			    path: '/user/gifts',
			    component:gifts
			}
			
		]
    },  {
        path: '/login',
        component: Login,
    },  {
        path: '/register',
        component: register,
    }, {
        path: '/repa',
        component: repa,
    },]
})



export default router